const React = require("react");
const { useCJDropshipping } = require("../context/CJDropshippingContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;

const DropshippingAllProducts = () => {
  const { t } = useCJDropshipping();
  return h(ProductCollectionPage, {
    title: t("h_cj_all_products_title", "CJ product catalog"),
    description: t("h_cj_all_products_desc", "Search CJ, review costs and import products into Elakay."),
  });
};
module.exports = { DropshippingAllProducts };
